<template>
  <svg
    width="737"
    height="438"
    viewBox="0 0 737 438"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.13703 425.761L5.91882 234.146L10.2284 230.764L10.3648 425.761H6.13703Z"
      fill="#F1F2F2"
    />
    <path
      d="M592.012 317.004L588.341 318.4L590.164 323.193L593.835 321.797L592.012 317.004Z"
      fill="#E2E3E3"
    />
    <path
      d="M10.1466 420.66L317.33 429.824H319.621L641.097 419.132L318.476 418.041L10.1466 420.66Z"
      fill="#D1D2D4"
    />
    <path
      d="M641.097 419.132L640.852 240.801L467.785 263.304L467.567 421.096L641.097 419.132Z"
      fill="#A7A9AB"
    />
    <path
      d="M10.474 235.782L140.39 255.884L139.572 424.178L10.2285 421.096L10.474 235.782Z"
      fill="#A7A9AB"
    />
    <path
      d="M10.4741 235.782L320.303 130.36L641.097 241.019L319.621 283.161L10.4741 235.782Z"
      fill="#D1D2D4"
    />
    <path
      d="M142.218 191.05L319.158 225.308L319.621 324.184L142.218 308.255V191.05Z"
      fill="#A7A9AB"
    />
    <path
      d="M10.2285 332.477L320.74 282.561L640.852 334.004L319.158 353.015L10.2285 332.477Z"
      fill="#D1D2D4"
    />
    <path
      d="M496.561 423.715V311.31L320.521 331.604L321.449 424.806L496.561 423.715Z"
      fill="#A7A9AB"
    />
    <path
      d="M496.343 310.437L496.807 191.486L282.635 229.018V289.052L320.467 282.424L496.343 310.437Z"
      fill="#A7A9AB"
    />
    <path
      d="M310.538 246.011L317.739 246.256L317.93 255.148H326.222L326.386 264.504H336.069L336.26 273.669H345.779L346.297 283.515L310.838 281.77L310.538 246.011Z"
      fill="#939599"
    />
    <path
      d="M10.474 235.783L320.521 131.261V122.941L9.54663 231.2L10.474 235.783Z"
      fill="#F1F2F2"
    />
    <path
      d="M351.125 282.07L320.985 277.924L312.993 278.797V196.505L351.125 206.324V282.07ZM222.137 164.21L221.673 298.654L320.767 282.943L387.648 292.544L387.866 210.934L222.109 164.237L222.137 164.21Z"
      fill="#E7E8E9"
    />
    <path
      d="M143.063 188.431L143.363 428.406L137.281 429.061L136.953 189.986L143.063 188.431Z"
      fill="#F1F2F2"
    />
    <path
      d="M277.616 357.352L277.152 348.842L286.508 348.405L286.044 356.915L277.616 357.352Z"
      fill="#BDBEC0"
    />
    <path
      d="M143.199 311.392L321.912 333.131L319.376 420.878L143.309 424.261L143.199 311.392Z"
      fill="#A7A9AB"
    />
    <path
      d="M182.859 423.715L182.395 415.205L243.357 413.023V423.715H182.859Z"
      fill="#D1D2D4"
    />
    <path
      d="M195.87 415.205L195.188 406.913L256.368 404.512V415.205H195.87Z"
      fill="#D1D2D4"
    />
    <path
      d="M208.88 406.912L208.198 398.402L269.161 396.22V406.912H208.88Z"
      fill="#D1D2D4"
    />
    <path
      d="M221.673 398.403L220.991 390.111L282.171 387.71V398.403H221.673Z"
      fill="#D1D2D4"
    />
    <path
      d="M230.347 390.547L229.665 382.037L290.845 379.855V390.547H230.347Z"
      fill="#D1D2D4"
    />
    <path
      d="M243.139 382.037L242.675 373.745L303.637 371.345V382.037H243.139Z"
      fill="#D1D2D4"
    />
    <path
      d="M256.15 373.745L255.468 365.235L316.648 363.025V373.745H256.15Z"
      fill="#D1D2D4"
    />
    <path
      d="M264.823 365.644L264.142 357.352L325.104 354.952V365.644H264.823Z"
      fill="#D1D2D4"
    />
    <path
      d="M290.627 348.842L289.918 340.331L351.125 338.149V348.842H290.627Z"
      fill="#BDBEC0"
    />
    <path
      d="M288.554 390.11L279.198 390.329L278.98 398.402H268.26L268.015 406.912H255.468L255.222 415.204H242.894L242.212 424.151L288.09 423.496L288.554 390.11Z"
      fill="#939599"
    />
    <path
      d="M387.648 323.53L221.427 298.654L220.991 426.988L244.503 426.551L244.039 308.037L290.381 314.801V425.897L387.648 424.369V323.53Z"
      fill="#E7E8E9"
    />
    <path
      d="M290.381 314.802L286.508 315.238L286.044 425.461L290.381 425.897V314.802Z"
      fill="white"
    />
    <path
      d="M351.125 206.106L348.397 206.761V279.888L351.125 280.542V206.106Z"
      fill="white"
    />
    <path
      d="M348.398 206.761L312.993 197.814V196.505L351.125 206.106L348.398 206.761Z"
      fill="#939599"
    />
    <path
      d="M457.829 424.179L457.202 383.046L416.097 385.829V424.152H412.169V382.146L461.048 378.846L461.757 424.124L457.829 424.179Z"
      fill="#E2E3E3"
    />
    <path
      d="M457.804 393.052L415.786 395.467L415.871 396.938L457.888 394.522L457.804 393.052Z"
      fill="#CDCFD1"
    />
    <path
      d="M420.024 418.805V402.494L452.074 401.13V417.905L420.024 418.832V418.805ZM421.497 403.912V417.278L450.628 416.459V402.658L421.497 403.912Z"
      fill="#CDCFD1"
    />
    <path
      d="M422.807 393.247C420.897 393.247 419.315 391.747 419.315 389.892C419.315 388.037 420.87 386.537 422.807 386.537C424.743 386.537 426.298 388.037 426.298 389.892C426.298 391.747 424.743 393.247 422.807 393.247ZM422.807 388.01C421.688 388.01 420.788 388.856 420.788 389.892C420.788 390.929 421.688 391.774 422.807 391.774C423.925 391.774 424.825 390.929 424.825 389.892C424.825 388.856 423.925 388.01 422.807 388.01Z"
      fill="#CDCFD1"
    />
    <path
      d="M412.169 365.589V354.733L429.762 347.533V318.947H433.69V350.178L416.097 357.379V361.361L457.829 358.17V354.733L439.363 349.933L439.118 317.883L443.045 317.829L443.264 346.905L461.757 351.706V361.798L412.169 365.589Z"
      fill="#E2E3E3"
    />
    <path
      d="M568.788 320.692L568.652 316.765L586.927 316.11C599.228 315.374 601.056 304.872 601.383 297.044C601.411 296.117 601.438 295.571 601.547 295.162C601.765 294.262 602.202 293.689 602.72 293.307L536.712 298.653L536.384 294.753L607.084 289.025L607.63 289.325C608.557 289.87 609.893 291.507 608.993 294.207C608.393 296.553 606.157 296.608 605.338 296.608C605.338 296.799 605.338 297.017 605.338 297.235C605.229 299.826 605.011 305.172 602.747 310.027C599.856 316.137 594.482 319.629 587.172 320.065L568.843 320.72L568.788 320.692Z"
      fill="#E7E8E9"
    />
    <path
      d="M537.803 313.601C535.621 309.783 535.266 305.5 535.075 302.964C535.075 302.745 535.048 302.473 535.021 302.227C534.093 302.391 532.129 302.527 531.12 300.372C529.565 297.045 531.529 295.49 531.747 295.326L532.211 294.999L536.903 294.753L537.094 298.518C537.612 298.763 538.13 299.199 538.512 299.936L538.594 300.1C538.839 300.7 538.894 301.436 539.003 302.663C539.194 304.9 539.494 308.61 541.239 311.692L537.83 313.628L537.803 313.601Z"
      fill="#E7E8E9"
    />
    <path
      d="M594.073 324.184V320.256C593.446 320.256 592.846 320.666 592.573 321.32C592.219 322.084 592.546 322.793 592.737 323.011C590.937 321.32 592.137 319.493 592.628 318.729C592.655 318.674 592.71 318.593 592.764 318.538C592.682 318.429 592.573 318.293 592.491 318.183L595.219 315.374C596.583 316.683 597.456 318.865 596.146 320.556C596.092 320.638 596.037 320.747 595.983 320.829C596.528 321.675 596.364 322.439 596.201 322.875C595.846 323.693 595.028 324.239 594.073 324.239V324.184Z"
      fill="#E2E3E3"
    />
    <path
      d="M580.872 274.624L572.089 264.122L573.616 262.868C573.943 262.595 576.916 260.249 580.271 260.631C581.99 260.822 583.49 261.722 584.636 263.195C585.863 264.859 586.327 266.686 585.999 268.432C585.427 271.569 582.644 273.451 582.317 273.669L580.844 274.596L580.872 274.624ZM577.871 264.886L581.472 269.168C581.799 268.732 582.099 268.241 582.181 267.696C582.317 267.014 582.099 266.304 581.526 265.541C581.062 264.941 580.517 264.613 579.862 264.532C579.208 264.45 578.498 264.613 577.871 264.886Z"
      fill="#E7E8E9"
    />
    <path
      d="M593.009 291.671C593.009 283.434 592.218 269.086 590.091 265.622C589.409 264.559 588.782 264.368 588.318 264.313C586.845 264.095 584.908 265.404 584.363 265.868L581.772 262.895C582.126 262.595 585.318 259.894 588.836 260.413C590.118 260.603 591.946 261.285 593.391 263.549C596.801 269.114 596.91 289.38 596.91 291.671H592.982H593.009Z"
      fill="#E7E8E9"
    />
    <path
      d="M601.753 295.083L539.64 299.884L539.715 300.863L601.829 296.062L601.753 295.083Z"
      fill="#E2E3E3"
    />
    <path
      d="M442.555 296.908L442.309 218.707L442.773 217.862L405.677 224.081L406.277 224.845L405.841 290.144L401.913 290.116L402.35 226.208L398.422 221.299L449.892 212.679L446.237 219.689L446.455 296.881L442.555 296.908Z"
      fill="#E2E3E3"
    />
    <path
      d="M424.689 225.309H423.216V292.735H424.689V225.309Z"
      fill="#CDCFD1"
    />
    <path
      d="M406.55 259.349L407.041 227.763L422.207 225.117V257.194L406.55 259.376V259.349ZM408.487 228.991L408.05 257.631L420.706 255.885V226.836L408.487 228.991Z"
      fill="#CDCFD1"
    />
    <path
      d="M422.179 292.326H420.706V263.277L407.805 265.022L408.023 289.926H406.55L406.305 263.741L422.179 261.586V292.326Z"
      fill="#CDCFD1"
    />
    <path
      d="M425.943 256.703L426.434 224.026L441.818 221.626V254.575L425.943 256.73V256.703ZM427.88 225.281L427.444 255.012L440.345 253.239V223.317L427.88 225.281Z"
      fill="#CDCFD1"
    />
    <path
      d="M440.345 295.817L440.127 260.631L427.662 262.213V293.417H426.189V260.903L441.6 258.967L441.818 295.817H440.345Z"
      fill="#CDCFD1"
    />
    <path
      d="M427.607 260.549C426.489 260.549 425.507 259.567 425.507 258.503C425.507 257.44 426.516 256.458 427.607 256.458C428.971 256.458 429.707 257.522 429.707 258.503C429.707 259.567 428.698 260.549 427.607 260.549ZM427.607 257.931C427.307 257.931 426.98 258.285 426.98 258.503C426.98 258.722 427.307 259.076 427.607 259.076C427.907 259.076 428.235 258.722 428.235 258.503C428.235 258.367 428.18 257.931 427.607 257.931Z"
      fill="#CDCFD1"
    />
    <path
      d="M420.543 261.422C419.452 261.422 418.443 260.44 418.443 259.377C418.443 258.313 419.479 257.331 420.543 257.331C421.552 257.331 422.643 258.04 422.643 259.377C422.643 260.413 421.634 261.422 420.543 261.422ZM420.543 258.804C420.243 258.804 419.915 259.158 419.915 259.377C419.915 259.595 420.243 259.949 420.543 259.949C420.843 259.949 421.17 259.595 421.17 259.377C421.17 258.831 420.679 258.804 420.543 258.804Z"
      fill="#CDCFD1"
    />
    <path
      d="M43.7235 324.403H39.7958L40.014 259.213L36.3044 252.557L88.62 259.404L83.9012 265.295L84.1194 317.202H80.1917L79.9735 263.904L81.2009 262.377L43.5326 257.44L43.9417 258.204L43.7235 324.403Z"
      fill="#E7E8E9"
    />
    <path
      d="M62.7895 263.931H61.3166V321.538H62.7895V263.931Z"
      fill="#DCDDDE"
    />
    <path
      d="M79.7007 297.044L64.0715 295.844V263.795L79.237 265.486L79.7007 297.072V297.044ZM65.5444 294.481L78.2005 295.462L77.7641 266.795L65.5444 265.431V294.481Z"
      fill="#DCDDDE"
    />
    <path
      d="M65.5444 320.474H64.0715V300.045L79.7007 301.463V317.201H78.2278V302.827L65.5444 301.654V320.474Z"
      fill="#DCDDDE"
    />
    <path
      d="M60.0619 295.544L44.4327 294.099V261.176L59.5982 262.867L60.0619 295.544ZM45.9056 292.762L58.589 293.935L58.1525 264.204L45.9329 262.84V292.762H45.9056Z"
      fill="#DCDDDE"
    />
    <path
      d="M45.9056 324.402H44.4327V298.517L60.0619 299.717V322.22H58.589V301.081L45.9056 300.099V324.402Z"
      fill="#DCDDDE"
    />
    <path
      d="M58.1527 299.226C57.7981 299.226 57.4162 299.117 57.1162 298.872C56.6252 298.517 56.3252 297.944 56.3252 297.344C56.3252 296.308 57.2526 295.353 58.3163 295.299C58.8073 295.19 59.2983 295.299 59.7347 295.599C60.2256 295.953 60.5257 296.526 60.5257 297.126C60.5257 298.163 59.5983 299.117 58.5345 299.172C58.3981 299.172 58.2618 299.199 58.1527 299.199V299.226ZM58.4254 296.772C58.1254 296.772 57.7981 297.126 57.7981 297.344C57.7981 297.453 57.8799 297.59 57.989 297.672C58.0436 297.699 58.1254 297.754 58.2072 297.726H58.4254C58.7255 297.699 59.0528 297.344 59.0528 297.126C59.0528 297.017 58.9709 296.881 58.8618 296.799C58.8073 296.772 58.7255 296.717 58.6436 296.744H58.4254V296.772Z"
      fill="#DCDDDE"
    />
    <path
      d="M65.4354 299.663C65.0808 299.663 64.699 299.554 64.3989 299.308C63.9079 298.954 63.6079 298.381 63.6079 297.781C63.6079 296.826 64.3171 295.79 65.5991 295.735C66.09 295.626 66.581 295.735 67.0174 296.035C67.5084 296.39 67.8084 296.962 67.8084 297.562C67.8084 298.599 66.881 299.554 65.8173 299.608C65.7082 299.608 65.5718 299.635 65.4354 299.635V299.663ZM65.7082 297.235C65.1354 297.235 65.0808 297.672 65.0808 297.808C65.0808 297.917 65.1626 298.053 65.2718 298.135C65.3263 298.163 65.4081 298.217 65.49 298.19H65.7082C66.0082 298.163 66.3355 297.808 66.3355 297.59C66.3355 297.481 66.2537 297.344 66.1446 297.262C66.09 297.235 66.0082 297.181 65.9264 297.208H65.7082V297.235Z"
      fill="#DCDDDE"
    />
    <path
      d="M289.972 233.218L232.338 220.89V216.089L289.972 228.636V233.218ZM233.811 219.69L288.499 231.364V229.809L233.811 217.917V219.69Z"
      fill="#A7A9AB"
    />
    <path
      d="M243.875 220.126L237.602 218.708V203.051L243.875 204.197V220.126ZM239.075 217.535L242.403 218.298V205.424L239.075 204.824V217.535Z"
      fill="#A7A9AB"
    />
    <path
      d="M250.258 221.407L245.594 220.453V207.824L250.258 208.779V221.407ZM247.067 219.253L248.785 219.607V209.979L247.067 209.624V219.253Z"
      fill="#A7A9AB"
    />
    <path
      d="M258.032 223.208L254.05 222.172V208.861L258.032 209.898V223.208ZM255.522 221.026L256.559 221.299V211.043L255.522 210.77V221.026Z"
      fill="#A7A9AB"
    />
    <path
      d="M262.341 224.026L257.677 223.072V210.879L262.341 211.834V224.026ZM259.15 221.872L260.868 222.226V213.034L259.15 212.68V221.872Z"
      fill="#A7A9AB"
    />
    <path
      d="M270.47 225.636L264.196 215.407L268.288 213.443L274.261 223.644L270.442 225.636H270.47ZM266.324 216.034L271.015 223.699L272.243 223.072L267.715 215.38L266.324 216.062V216.034Z"
      fill="#A7A9AB"
    />
    <path
      d="M265.778 224.899L261.114 223.944V207.906L265.778 209.488V224.872V224.899ZM262.587 222.744L264.305 223.099V210.552L262.587 209.979V222.744Z"
      fill="#A7A9AB"
    />
    <path
      d="M169.303 301.054H165.375V273.096L160.929 266.959L205.553 273.915L201.489 278.252V295.599H197.561V276.697L197.588 276.67L169.303 272.251V301.054Z"
      fill="#E2E3E3"
    />
    <path
      d="M170.161 273.07L169.945 274.527L196.44 278.458L196.656 277.001L170.161 273.07Z"
      fill="#CDCFD1"
    />
    <path
      d="M170.654 283.535L170.436 284.991L196.683 288.919L196.901 287.462L170.654 283.535Z"
      fill="#CDCFD1"
    />
    <path
      d="M170.852 285.038L170.633 286.495L196.66 290.422L196.879 288.965L170.852 285.038Z"
      fill="#CDCFD1"
    />
    <path
      d="M171.021 273.778H169.548V300.618H171.021V273.778Z"
      fill="#CDCFD1"
    />
    <path
      d="M193.006 288.18L190.905 277.569L194.397 276.833L196.497 287.443L193.006 288.18ZM192.624 278.715L194.151 286.434L194.751 286.298L193.224 278.579L192.624 278.715Z"
      fill="#CDCFD1"
    />
    <path
      d="M173.558 274.433H172.085V284.252H173.558V274.433Z"
      fill="#CDCFD1"
    />
    <path
      d="M175.822 274.869H174.349V284.688H175.822V274.869Z"
      fill="#CDCFD1"
    />
    <path
      d="M177.185 275.087H175.713V284.907H177.185V275.087Z"
      fill="#CDCFD1"
    />
    <path
      d="M173.558 289.052H172.085V299.963H173.558V289.052Z"
      fill="#CDCFD1"
    />
    <path d="M175.822 289.49H174.349V299.745H175.822V289.49Z" fill="#CDCFD1" />
    <path
      d="M177.185 289.707H175.713V299.526H177.185V289.707Z"
      fill="#CDCFD1"
    />
    <path
      d="M179.477 277.051H178.004V285.343H179.477V277.051Z"
      fill="#CDCFD1"
    />
    <path d="M181.086 277.27H179.613V285.562H181.086V277.27Z" fill="#CDCFD1" />
    <path
      d="M182.668 277.488H181.195V285.779H182.668V277.488Z"
      fill="#CDCFD1"
    />
    <path
      d="M188.832 277.051H187.359V286.871H188.832V277.051Z"
      fill="#CDCFD1"
    />
    <path
      d="M230.592 289.925L230.347 251.712L236.456 252.503L236.947 289.462L234.247 289.489L233.811 254.876L233.047 254.794L233.292 289.898L230.592 289.925Z"
      fill="#BDBEC0"
    />
    <path
      d="M302.983 278.879L302.574 272.96L302.901 278.279L300.228 278.443L299.682 269.769L305.138 270.642L305.656 278.715L302.983 278.879Z"
      fill="#BDBEC0"
    />
    <path
      d="M235.977 272.021L235.632 274.672L289.294 281.66L289.639 279.01L235.977 272.021Z"
      fill="#BDBEC0"
    />
    <path
      d="M253.477 271.541C250.394 261.531 236.047 262.431 235.911 262.459L235.72 259.785C236.402 259.731 252.358 258.749 256.041 270.778L253.477 271.569V271.541Z"
      fill="#BDBEC0"
    />
    <path
      d="M297.5 279.479C297.309 274.351 293.054 273.833 292.563 273.778H292.454L256.341 268.105V274.596H253.668V264.968L292.836 271.078C295.318 271.269 299.982 273.26 300.201 279.343L297.5 279.452V279.479Z"
      fill="#BDBEC0"
    />
    <path
      d="M235.306 280.539L234.988 283.194L266.052 286.909L266.37 284.255L235.306 280.539Z"
      fill="#BDBEC0"
    />
    <path
      d="M496.561 185.813L500.898 187.122L500.68 425.46L496.807 425.242"
      fill="#E7E8E9"
    />
    <path
      d="M320.767 282.943L320.521 275.306L640.852 327.758V334.004L320.767 282.943Z"
      fill="#E7E8E9"
    />
    <path
      d="M320.521 131.042V123.16L641.097 235.946V242.383L320.521 131.042Z"
      fill="#E7E8E9"
    />
    <path
      d="M217.145 429.061L216.872 163.964L222.109 161.619L221.836 429.061H217.145Z"
      fill="#F1F2F2"
    />
    <path
      d="M90.7476 410.186H86.8198V422.624H90.7476V410.186Z"
      fill="#E7E8E9"
    />
    <path
      d="M83.3557 420.987L43.9691 419.405V413.786L83.3557 415.368V420.987ZM45.442 417.987L81.8828 419.46V416.787L45.442 415.314V417.987Z"
      fill="#DCDDDE"
    />
    <path
      d="M73.0181 397.093L74.6274 393.602L82.6193 394.038L85.1287 396.221V400.803C85.1287 400.803 88.5655 402.985 88.5655 404.731V419.351L86.0561 421.969H82.6193C81.9374 421.969 78.7188 420.878 77.8187 420.878C76.9186 420.878 73.4818 419.351 73.4818 419.132C73.4818 418.914 70.2905 401.676 70.2905 401.676L73.0454 397.093H73.0181Z"
      fill="#A7A9AB"
    />
    <path
      d="M45.1692 401.239C45.1692 403.203 43.56 404.73 41.2688 404.73C39.2231 404.73 37.3683 402.985 37.3683 401.021C37.3683 399.057 38.9776 397.529 41.2688 397.529C43.56 397.529 45.1692 399.275 45.1692 401.239Z"
      fill="#A7A9AB"
    />
    <path
      d="M328.513 120.132L647.48 235.564L489.033 144.571L137.635 3.79932L328.513 120.132Z"
      fill="#939599"
    />
    <path
      d="M328.295 128.178L647.698 240.174V235.564L328.295 120.132V128.178Z"
      fill="#D1D2D4"
    />
    <path
      d="M10.4741 235.783L320.521 131.261V122.941L10.4741 230.764V235.783Z"
      fill="#F1F2F2"
    />
    <path
      d="M10.2285 332.477L10.0103 327.458L320.521 275.306L320.767 282.943L10.2285 332.477Z"
      fill="#F1F2F2"
    />
    <path
      d="M496.125 187.995L500.434 189.304L500.216 427.643H496.343"
      fill="#E7E8E9"
    />
    <path
      d="M508.099 384.001L507.608 355.961L525.01 354.215L525.256 382.992L508.099 383.974V384.001ZM509.735 357.87L510.145 381.764L523.128 381.028L522.91 356.561L509.735 357.87Z"
      fill="#E7E6E6"
    />
    <path
      d="M522.336 376.648L510.697 377.087L510.727 377.877L522.366 377.438L522.336 376.648Z"
      fill="#E7E6E6"
    />
    <path
      d="M512.409 355.988C512.409 355.825 511.918 352.115 513.936 349.797C514.945 348.624 516.391 348.024 518.191 348.024L523.783 347.478L524.137 353.506L518.546 354.052C518.546 354.052 518.273 354.406 518.355 355.306L516.254 355.497C516.145 354.243 516.364 353.288 516.964 352.661C517.509 352.088 518.137 351.979 518.382 351.952L521.901 351.597L521.792 349.769L518.218 350.124C517.018 350.124 516.118 350.479 515.491 351.188C514.1 352.77 514.454 355.688 514.454 355.716L512.381 355.988H512.409Z"
      fill="#E7E6E6"
    />
    <path
      d="M513.309 375.463V373.581L519.8 373.09V374.972L513.309 375.463ZM514.1 374.318V374.618L519.009 374.236V373.936L514.1 374.318Z"
      fill="#E7E6E6"
    />
    <path
      d="M511.863 381.11C511.017 381.11 510.336 380.455 510.336 379.637C510.336 378.819 511.017 378.164 511.863 378.164C512.709 378.164 513.39 378.819 513.39 379.637C513.39 380.455 512.709 381.11 511.863 381.11ZM511.863 378.928C511.454 378.928 511.127 379.255 511.127 379.637C511.127 380.019 511.454 380.346 511.863 380.346C512.272 380.346 512.599 380.019 512.599 379.637C512.599 379.255 512.245 378.928 511.863 378.928Z"
      fill="#E7E6E6"
    />
    <path
      d="M515.954 380.891C515.109 380.891 514.427 380.237 514.427 379.418C514.427 378.6 515.109 377.946 515.954 377.946C516.8 377.946 517.482 378.6 517.482 379.418C517.482 380.237 516.8 380.891 515.954 380.891ZM515.954 378.709C515.545 378.709 515.218 379.037 515.218 379.418C515.218 379.8 515.545 380.128 515.954 380.128C516.364 380.128 516.691 379.8 516.691 379.418C516.691 379.037 516.364 378.709 515.954 378.709Z"
      fill="#E7E6E6"
    />
    <path
      d="M556.678 420.005H555.205V388.31L589.764 386.728L590.009 419.569H588.536L588.318 388.256L556.678 389.701V420.005Z"
      fill="#DCDDDE"
    />
    <path
      d="M551.959 420.005H548.031V389.62L542.794 381.764L602.256 378.791L597.401 387.765V419.569H593.473V386.756L595.464 383.074L549.886 385.338L551.959 388.42V420.005Z"
      fill="#E7E8E9"
    />
    <path
      d="M560.769 420.005H559.296V401.894C559.296 395.102 565.051 389.592 572.143 389.592C579.235 389.592 584.99 395.129 584.99 401.894V419.787H583.517V401.894C583.517 395.92 578.417 391.065 572.143 391.065C565.87 391.065 560.769 395.92 560.769 401.894V420.005Z"
      fill="#DCDDDE"
    />
    <path
      d="M563.879 420.033L563.606 412.532L580.626 412.041V420.005H579.153V413.568L565.133 413.95L565.352 419.978L563.879 420.033Z"
      fill="#DCDDDE"
    />
    <path
      d="M524.356 420.687L523.728 401.321L500.707 401.758L500.68 400.285L525.119 399.821L525.828 420.633L524.356 420.687Z"
      fill="#DCDDDE"
    />
    <path
      d="M530.956 420.223H527.029V398.948L500.243 399.493L500.189 395.566L534.611 394.884V401.239L530.956 401.676V420.223Z"
      fill="#E7E8E9"
    />
    <path
      d="M109.893 339.001L109.204 390.302L111.304 390.331L111.993 339.029L109.893 339.001Z"
      fill="#E7E6E6"
    />
    <path
      d="M104.604 410.595L104.849 394.747H119.333L118.842 410.377L104.577 410.595H104.604ZM105.613 395.538L105.395 409.804L118.078 409.613L118.515 395.538H105.613Z"
      fill="#E7E6E6"
    />
    <path
      d="M104.822 422.569H102.094V418.178L105.968 419.023L104.822 422.542V422.569ZM102.885 421.778H104.249L104.958 419.623L102.885 419.16V421.751V421.778Z"
      fill="#E7E6E6"
    />
    <path
      d="M121.106 423.06L118.351 422.76L117.505 419.242L121.379 418.669L121.106 423.06ZM119.006 422.051L120.369 422.187L120.533 419.596L118.487 419.896L119.006 422.051Z"
      fill="#E7E6E6"
    />
    <path
      d="M122.06 420.033H101.358L101.603 391.638L122.797 391.147L122.06 420.033ZM103.594 417.796H119.878L120.506 393.439L103.813 393.821L103.594 417.796Z"
      fill="#E7E6E6"
    />
    <path
      d="M111.614 416.241C110.932 416.241 110.523 415.859 110.523 415.177C110.523 414.495 110.932 414.114 111.614 414.114C112.296 414.114 112.705 414.495 112.705 415.177C112.705 415.859 112.296 416.241 111.614 416.241ZM111.614 414.932C111.341 414.932 111.314 414.986 111.314 415.205C111.314 415.423 111.314 415.477 111.614 415.477C111.914 415.477 111.914 415.423 111.914 415.205C111.914 414.986 111.914 414.932 111.614 414.932Z"
      fill="#E7E6E6"
    />
    <path
      d="M114.232 339.441L113.546 390.525L115.646 390.553L116.333 339.469L114.232 339.441Z"
      fill="#E7E6E6"
    />
    <path
      d="M109.186 391.556L108.559 391.283L109.104 389.974H115.705L116.251 391.038L115.651 391.365L115.296 390.656H109.568L109.186 391.556Z"
      fill="#E7E6E6"
    />
    <path
      d="M112.514 409.095C112.514 409.095 113.441 408.44 113.196 406.04C113.414 405.849 114.341 408.249 112.514 409.095ZM111.396 408.876C110.032 407.785 110.032 405.603 110.032 405.603C110.25 406.694 112.759 409.967 111.396 408.876ZM115.269 406.476C114.805 404.294 114.123 403.203 114.805 402.33C115.487 401.457 113.659 402.985 113.441 404.731C113.441 406.476 112.077 399.275 113.659 397.748C115.269 396.002 109.323 401.457 110.223 405.385C110.223 405.385 108.395 402.767 108.613 400.803C108.832 398.839 105.422 405.603 110.223 409.749C110.223 409.749 111.832 410.404 112.978 410.186C112.759 409.995 115.732 408.686 115.269 406.476Z"
      fill="#E7E6E6"
    />
    <path
      d="M83.3557 416.841L43.9691 415.259V408.113L83.3557 409.695V416.841ZM45.442 413.841L81.8828 415.314V411.113L45.442 409.64V413.841Z"
      fill="#CDCFD1"
    />
    <path
      d="M87.7745 398.839H83.8468C83.8468 397.939 82.8921 396.875 81.692 396.875H81.6101L45.8239 395.348C44.7874 395.348 43.7237 395.893 43.7237 397.093H39.7959C39.7959 393.847 42.4144 391.42 45.8785 391.42H45.9603L81.7738 392.947C84.9924 392.947 87.8018 395.73 87.8018 398.839H87.7745Z"
      fill="#E7E8E9"
    />
    <path
      d="M86.2742 408.44C83.0011 408.44 80.4372 405.958 80.4372 402.767C80.4372 399.766 83.0557 397.312 86.2742 397.312C89.4928 397.312 92.1113 399.794 92.1113 402.985C92.1113 405.985 89.4928 408.44 86.2742 408.44ZM86.2742 401.239C85.265 401.239 84.3649 401.948 84.3649 402.767C84.3649 403.585 85.0468 404.512 86.2742 404.512C87.2835 404.512 88.1836 403.803 88.1836 402.985C88.1836 402.167 87.5017 401.239 86.2742 401.239Z"
      fill="#E7E8E9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.99158 236.709L138.481 4.01709L335.141 123.241L4.99158 236.709Z"
      fill="#E7E8E9"
    />
    <path
      d="M41.296 406.258C38.1865 406.258 35.4589 403.612 35.4589 400.585C35.4589 397.557 37.9683 395.129 41.296 395.129C44.6237 395.129 47.1331 397.612 47.1331 400.803C47.1331 403.912 44.6237 406.258 41.296 406.258ZM41.296 399.057C40.1504 399.057 39.3867 399.657 39.3867 400.585C39.3867 401.512 40.3413 402.33 41.296 402.33C42.4416 402.33 43.2053 401.73 43.2053 400.803C43.2053 399.957 42.5234 399.057 41.296 399.057Z"
      fill="#E7E8E9"
    />
    <path
      d="M64.8625 394.911H63.3896V419.569H64.8625V394.911Z"
      fill="#CDCFD1"
    />
    <path
      d="M44.7972 406.94L44.6389 410.865L82.5491 412.394L82.7074 408.469L44.7972 406.94Z"
      fill="#E7E8E9"
    />
    <path
      d="M44.7893 416.746L44.631 420.671L82.5412 422.2L82.6995 418.276L44.7893 416.746Z"
      fill="#E7E8E9"
    />
    <path
      d="M90.7476 405.385H86.8198V423.715H90.7476V405.385Z"
      fill="#E7E8E9"
    />
    <path
      d="M6.13715 425.76L320.767 437.244L320.521 429.061L10.1467 420.66L6.13715 425.76Z"
      fill="#F1F2F2"
    />
    <path
      d="M84.5832 404.076H80.6554V422.624H84.5832V404.076Z"
      fill="#E7E8E9"
    />
    <path
      d="M46.6966 402.767H42.7689V421.751H46.6966V402.767Z"
      fill="#E7E8E9"
    />
    <path
      d="M40.5049 403.421H36.5771V421.533H40.5049V403.421Z"
      fill="#E7E8E9"
    />
    <path
      d="M58.4254 145.88L58.6982 220.726L53.6521 221.408L53.3794 152.972L58.4254 145.88Z"
      fill="#F1F2F2"
    />
    <path
      d="M57.9344 217.753L58.1799 148.854L181.931 176.866L57.9344 217.753Z"
      fill="#A7A9AB"
    />
    <path
      d="M235.584 63.3701L236.102 159.055L335.141 124.741L235.584 63.3701Z"
      fill="#A7A9AB"
    />
    <path
      d="M231.247 160.555L237.166 159.546L236.92 61.9795L231.247 59.0337V160.555Z"
      fill="#F1F2F2"
    />
    <path
      d="M0 242.383L138.399 0.853516L342.288 124.605L0 242.383ZM140.035 7.20884L10.0376 234.064L331.514 123.46L140.035 7.20884Z"
      fill="#A2A3A6"
    />
    <path
      d="M737 413.977V418.096L320.767 437.244L320.521 429.061L639.706 417.496L645.08 417.305L735.336 414.032L737 413.977Z"
      fill="#D2D4D5"
    />
    <path
      d="M735.336 335.395V414.032L704.814 415.123L699.113 415.341L652.608 417.033H652.58L645.08 417.278V415.778L645.052 412.641V409.613V406.449V401.24L645.025 392.293V390.847L644.998 381.901V380.455V374.127V370.854V368.372L644.889 317.557L735.336 335.395Z"
      fill="#E7E8E9"
    />
    <path
      d="M722.025 397.503C721.862 394.093 719.298 391.229 715.943 390.656L697.777 387.71L681.139 377.318C679.884 376.527 678.438 376.145 676.938 376.2L673.692 376.364L673.638 375.3H674.019C674.701 375.245 675.247 374.673 675.22 373.991C675.192 373.309 674.592 372.763 673.91 372.79H673.528L673.365 369.517H673.747C674.429 369.463 674.974 368.89 674.947 368.208C674.92 367.526 674.32 366.981 673.638 367.008H673.256L673.201 366.053C673.174 365.371 672.574 364.853 671.892 364.88C671.21 364.908 670.692 365.508 670.719 366.19L670.774 367.172L644.943 368.399H644.534L644.479 367.444C644.452 366.762 643.852 366.244 643.17 366.271C642.488 366.299 641.97 366.872 641.997 367.581L642.052 368.563H641.97C641.288 368.59 640.743 369.19 640.77 369.872C640.797 370.554 641.397 371.099 642.079 371.072H642.161L642.325 374.345H642.243C641.561 374.372 641.015 374.973 641.043 375.654C641.07 376.336 641.67 376.882 642.352 376.855H642.434L642.488 377.918L639.679 378.055V379.473L644.97 379.228L676.993 377.727C678.193 377.673 679.338 377.973 680.348 378.6L697.095 389.074C697.095 389.074 697.286 389.156 697.368 389.183L715.67 392.157C717.689 392.511 719.325 393.848 720.089 395.648L717.77 395.757C716.979 395.784 716.352 396.466 716.379 397.284C716.461 398.894 717.825 400.148 719.461 400.067L720.662 400.012L720.771 402.549L710.433 403.04C708.496 400.012 705.06 398.075 701.186 398.266C697.341 398.457 694.095 400.694 692.431 403.885L657.217 405.549C655.281 402.521 651.844 400.585 647.971 400.776C646.934 400.83 645.952 401.021 645.025 401.349C642.788 402.14 640.934 403.64 639.679 405.576V412.341L641.343 412.259C641.697 414.496 643.034 416.405 644.889 417.469H645.052V417.387L652.553 417.114C654.299 415.859 655.472 413.868 655.581 411.577L658.09 411.468C658.09 411.468 658.118 411.468 658.172 411.468C658.172 411.468 658.199 411.468 658.254 411.468L691.94 409.886C691.94 409.886 691.967 409.886 692.022 409.886C692.022 409.886 692.049 409.886 692.104 409.886L694.613 409.777C694.995 412.368 696.74 414.496 699.086 415.423L704.814 415.232C707.133 414.114 708.742 411.795 708.878 409.122L711.388 409.013C711.388 409.013 711.415 409.013 711.47 409.013C711.524 409.013 711.497 409.013 711.551 409.013L719.652 408.631C721.262 408.549 722.489 407.186 722.407 405.604L722.025 397.639V397.503ZM670.883 369.626L671.046 372.9L667.582 373.063C667.582 373.063 667.664 372.79 667.637 372.654L667.555 370.936C667.555 370.499 667.337 370.117 667.064 369.817L670.855 369.626H670.883ZM657.981 370.936L665.7 370.554C665.918 370.554 666.137 370.717 666.164 370.963L666.246 372.681C666.246 372.9 666.109 373.063 665.891 373.091L658.036 373.472C657.845 373.472 657.654 373.309 657.654 373.091L657.572 371.372C657.572 371.154 657.736 370.936 657.981 370.908V370.936ZM644.67 370.854H644.998L646.716 370.745C646.716 370.772 646.716 370.827 646.716 370.881L646.88 374.018L645.052 374.1H644.889L644.725 370.854H644.67ZM644.998 377.7V376.609L646.934 376.527V377.155C646.962 377.291 647.043 377.427 647.071 377.591L645.025 377.7H644.998ZM648.107 370.799C648.107 370.799 648.134 370.717 648.162 370.663L651.571 370.499C651.571 370.499 651.626 370.554 651.626 370.636L651.789 373.772L648.271 373.936L648.107 370.799ZM651.517 377.373L648.871 377.509C648.653 377.509 648.435 377.346 648.407 377.1V376.473L651.926 376.309V376.936C651.98 377.155 651.789 377.373 651.544 377.4L651.517 377.373ZM653.099 370.581C653.099 370.581 653.071 370.472 653.044 370.445L656.508 370.281C656.263 370.608 656.126 371.018 656.126 371.454L656.208 373.172C656.208 373.309 656.29 373.445 656.317 373.554L653.262 373.691L653.126 370.554L653.099 370.581ZM667.364 376.636L654.544 377.236C654.326 377.236 654.108 377.073 654.081 376.827V376.2L667.773 375.545V376.173C667.801 376.391 667.637 376.609 667.391 376.636H667.364ZM669.164 376.555C669.164 376.418 669.246 376.282 669.219 376.118V375.491L671.183 375.409L671.237 376.473L669.164 376.582V376.555ZM654.244 410.841C654.381 414.005 651.926 416.705 648.762 416.841C647.398 416.896 646.116 416.487 645.107 415.75C643.716 414.768 642.788 413.186 642.707 411.359C642.597 409.34 643.552 407.513 645.08 406.422C645.98 405.767 647.043 405.358 648.216 405.304C651.38 405.14 654.081 407.622 654.244 410.813V410.841ZM691.285 408.358L658.827 409.886C658.69 408.795 658.418 407.813 657.981 406.858L691.831 405.276C691.476 406.258 691.313 407.295 691.285 408.386V408.358ZM707.487 408.358C707.624 411.523 705.169 414.223 702.005 414.359C698.813 414.523 696.086 412.041 695.949 408.877C695.786 405.685 698.268 402.958 701.459 402.821C704.623 402.658 707.324 405.14 707.487 408.331V408.358ZM719.543 407.049L712.07 407.404C711.933 406.313 711.66 405.331 711.224 404.376L720.853 403.913L720.934 405.522C720.962 406.313 720.362 406.995 719.543 407.049Z"
      fill="#D1D2D4"
    />
    <path
      d="M669.792 396.057C669.792 396.466 670.146 396.766 670.528 396.739L676.611 396.439C677.02 396.439 677.32 396.084 677.293 395.702C677.293 395.293 676.938 394.993 676.556 395.02L670.474 395.32C670.092 395.32 669.764 395.675 669.792 396.057Z"
      fill="#D1D2D4"
    />
    <path
      d="M649.144 396.302C648.735 396.302 648.434 396.657 648.462 397.039C648.462 397.448 648.816 397.748 649.198 397.721L655.281 397.448C655.69 397.448 655.99 397.093 655.963 396.711C655.963 396.302 655.608 396.002 655.226 396.03L649.144 396.302Z"
      fill="#D1D2D4"
    />
    <path
      d="M697.995 408.795C698.104 410.841 699.85 412.423 701.895 412.313C703.941 412.204 705.523 410.459 705.414 408.413C705.305 406.367 703.559 404.758 701.514 404.867C699.468 404.976 697.859 406.695 697.968 408.768L697.995 408.795Z"
      fill="#D1D2D4"
    />
    <path
      d="M648.298 407.404C646.252 407.513 644.643 409.231 644.752 411.304C644.861 413.35 646.607 414.932 648.653 414.823C650.698 414.714 652.28 412.968 652.171 410.922C652.062 408.877 650.316 407.267 648.271 407.376L648.298 407.404Z"
      fill="#D1D2D4"
    />
    <path
      d="M695.486 389.783C695.431 388.719 694.531 387.901 693.467 387.928L691.476 388.01C691.476 388.01 691.34 387.765 691.231 387.683L678.438 379.664C677.62 379.173 676.693 378.927 675.738 378.954L666.491 379.391L644.998 380.427L641.615 380.591C640.934 380.591 640.306 380.782 639.733 381.109V382.828C640.279 382.337 640.961 382.064 641.697 382.009L645.025 381.846L650.453 381.6L650.862 390.547L645.025 390.82L639.706 391.065V392.538L645.025 392.292L688.83 390.247C688.885 390.71 689.103 391.147 689.43 391.447C689.785 391.774 690.303 391.965 690.822 391.938L695.022 391.747C695.322 391.747 695.54 391.501 695.54 391.201L695.486 389.81V389.783ZM652.28 390.52L651.871 381.573L665.837 380.918L666.246 389.865L652.28 390.52ZM689.267 388.774L667.719 389.783L667.31 380.864L675.82 380.455C676.474 380.455 677.129 380.591 677.674 380.918L689.676 388.447C689.54 388.556 689.403 388.637 689.294 388.774H689.267Z"
      fill="#D1D2D4"
    />
    <path
      d="M737 331.494V416.596L735.336 417.768V335.395L644.889 317.556L644.998 368.371V370.854V374.127V380.455V381.9L645.025 390.847V392.293L645.052 401.239V406.449V409.613V412.641L645.08 415.777V417.359L644.916 417.387L639.706 417.659V307.682L642.352 307L733.972 328.685L737 331.494Z"
      fill="#D2D4D5"
    />
    <path
      d="M679.925 348.737L648.079 349.61L648.189 353.645L680.036 352.772L679.925 348.737Z"
      fill="#D1D2D4"
    />
    <path
      d="M667.13 337.716L649.189 338.208L649.477 348.705L667.418 348.213L667.13 337.716Z"
      fill="#D1D2D4"
    />
    <path
      d="M665.968 339.113L650.399 339.54L650.498 343.139L666.067 342.712L665.968 339.113Z"
      fill="#E7E8E9"
    />
    <path
      class="hide-on-hover"
      opacity="0.5"
      d="M10 233.964L331.344 123.279L139.917 7L10 233.964Z"
      fill="#84CEF4"
    />
    <path
      class="hide-on-hover"
      opacity="0.5"
      d="M10.1909 238.712L10.2454 327.348L137 306.035L136.863 195.132L10.1909 238.712Z"
      fill="#F4E600"
    />
    <path
      class="hide-on-hover"
      opacity="0.5"
      d="M143.107 304.998L216.858 292.609L216.722 167.624L142.971 193.03L143.107 304.998Z"
      fill="#84CEF4"
    />
    <path
      class="hide-on-hover"
      opacity="0.5"
      d="M222.012 165.823L221.903 291.872L320.356 275.198L495.996 304.043L495.86 191.884L321.883 131.411L222.012 165.823Z"
      fill="#F4E600"
    />
    <path
      class="hide-on-hover"
      opacity="0.5"
      d="M500.631 193.549L500.549 304.78L640.555 327.702V242.178L500.631 193.549Z"
      fill="#6ABB80"
    />
    <path
      class="hide-on-hover"
      opacity="0.5"
      d="M10.1909 332.423L10.1091 420.649L136.863 424.088V312.202L10.1909 332.423Z"
      fill="#F4E600"
    />
    <path
      class="hide-on-hover"
      opacity="0.5"
      d="M216.859 299.431L143.107 311.302L143.216 424.252L217.049 426.244L216.859 299.431Z"
      fill="#84CEF4"
    />
    <path
      class="hide-on-hover"
      opacity="0.5"
      d="M221.957 298.558L320.574 282.839L495.996 310.865L496.078 422.669L320.383 429L221.739 426.271L221.957 298.558Z"
      fill="#E53333"
    />
    <path
      class="hide-on-hover"
      opacity="0.5"
      d="M500.549 311.602L500.413 422.505L639.409 417.484V333.761L500.549 311.602Z"
      fill="#F4E600"
    />
    <path
      class="hide-on-hover"
      opacity="0.5"
      d="M735 335.343V413.991L644.753 417.266L644.562 317.469L735 335.343Z"
      fill="#E53333"
    />
    <text
      fill="#38322D"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Barlow"
      font-size="14"
      font-weight="600"
      letter-spacing="0em"
    >
      <tspan x="665" y="363">{{ toLocal("house.garage").toUpperCase() }}</tspan>
    </text>
    <text
      fill="#38322D"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Barlow"
      font-size="14"
      font-weight="600"
      letter-spacing="0em"
    >
      <tspan x="530.037" y="367">
        {{ toLocal("house.dining_room").toUpperCase() }}
      </tspan>
    </text>
    <text
      fill="#38322D"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Barlow"
      font-size="14"
      font-weight="600"
      letter-spacing="0em"
    >
      <tspan x="302.332" y="367">
        {{ toLocal("house.kitchen").toUpperCase() }}
      </tspan>
    </text>
    <text
      fill="#38322D"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Barlow"
      font-size="14"
      font-weight="600"
      letter-spacing="0em"
    >
      <tspan x="159.033" y="367">
        {{ toLocal("house.hall").toUpperCase() }}
      </tspan>
    </text>
    <text
      fill="#38322D"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Barlow"
      font-size="14"
      font-weight="600"
      letter-spacing="0em"
    >
      <tspan x="21.0332" y="367">
        {{ toLocal("house.living_room").toUpperCase() }}
      </tspan>
    </text>
    <text
      fill="#38322D"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Barlow"
      font-size="14"
      font-weight="600"
      letter-spacing="0em"
    >
      <tspan x="30" y="275" class="smaller-malta" v-if="lang == 'MT' || lang == 'IT'">
        {{ toLocal("house.bedroom").toUpperCase() }}
      </tspan>
      <tspan x="47.0039" y="248" class="smaller-malta" v-if="lang != 'MT' && lang != 'IT'">
        {{ toLocal("house.bedroom").toUpperCase() }}
      </tspan>
    </text>
    <text
      fill="#38322D"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Barlow"
      font-size="14"
      font-weight="600"
      letter-spacing="0em"
    >
      <tspan x="302.004" y="181">
        {{ toLocal("house.bedroom").toUpperCase() }}
      </tspan>
    </text>
    <text
      fill="#38322D"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Barlow"
      font-size="14"
      font-weight="600"
      letter-spacing="0em"
    >
      <tspan x="506.287" y="244">
        {{ toLocal("house.bathroom").toUpperCase() }}
      </tspan>
    </text>
    <text
      fill="#38322D"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Barlow"
      font-size="14"
      font-weight="600"
      letter-spacing="0em"
    >
      <tspan x="136.1" y="111">
        {{ toLocal("house.attic").toUpperCase() }}
      </tspan>
    </text>
    <text
      fill="#38322D"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Barlow"
      font-size="14"
      font-weight="600"
      letter-spacing="0em"
    >
      <tspan x="142" y="248">
        {{ toLocal("house.landing").toUpperCase() }}
      </tspan>
    </text>
  </svg>
</template>

<script>
import store from "@/store";
export default {
  name: "HouseComponent",
  data() {
    return {
      garage: this.toLocal("house.garage"),
      lang: store.state.lang,
    };
  },
};
</script>

<style lang="scss" scoped>
svg {
  width: 100%;
  .room {
    transition: opacity 0.3s;
    &:hover {
      opacity: 0;
    }
  }

  .hide-on-hover {
    transition: 0.25s;
    &:hover {
      opacity: 0;
    }
  }
}
</style>
